var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBath = function SvgBath(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.188 2.83v4.36h14.259c.31 0 .562.252.562.563v2.38a4.052 4.052 0 0 1-3.078 3.933v.708a.562.562 0 1 1-1.125 0v-.59H4.675v.59a.562.562 0 1 1-1.125 0v-.63a4.05 4.05 0 0 1-3.487-4.012V2.83a2.146 2.146 0 0 1 4.281-.215 1.56 1.56 0 0 1 1.01 1.46v.998c0 .311-.252.563-.562.563H2.795a.563.563 0 0 1-.563-.563v-.999c0-.655.405-1.216.978-1.446a1.021 1.021 0 0 0-2.022.202Zm10.771 10.228H4.113a2.924 2.924 0 0 1-2.925-2.926V8.315h4.128v2.681c0 .311.252.563.563.563h5.25c.31 0 .563-.252.563-.563v-2.68h3.192v1.816a2.925 2.925 0 0 1-2.925 2.926ZM6.441 8.316h4.126v2.118H6.44V8.316ZM3.357 4.51v-.437a.435.435 0 0 1 .872 0v.437h-.872Z",
    fill: "#25292D"
  })));
};
export default SvgBath;